import { useGetIdentity, useGetList, useListContext } from "ra-core";
import { ToggleFilterButton } from "@/components/admin/toggle-filter-button";
import { ActiveFilterButton } from "../misc/ActiveFilterButton";
import type { Sale } from "../types";

const formatName = (sale: Sale) =>
  `${sale.first_name} ${sale.last_name}`.trim();

export const SalesFilterButtons = ({
  size,
  className,
}: {
  size?: "default" | "sm" | "lg" | "icon" | null;
  className?: string;
}) => {
  const { identity } = useGetIdentity();
  const { data: sales } = useGetList<Sale>("sales", {
    pagination: { page: 1, perPage: 100 },
    sort: { field: "first_name", order: "ASC" },
    filter: { "disabled@eq": false },
  });

  if (!sales) return null;

  return (
    <>
      {sales
        .filter((sale) => sale.user_id !== identity?.id)
        .map((sale) => (
          <ToggleFilterButton
            key={sale.id}
            className={className}
            label={formatName(sale)}
            value={{ sales_id: sale.id }}
            size={size ?? undefined}
          />
        ))}
    </>
  );
};

export const ActiveSalesFilters = ({ className }: { className?: string }) => {
  const { identity } = useGetIdentity();
  const { filterValues } = useListContext();
  const { data: sales } = useGetList<Sale>("sales", {
    pagination: { page: 1, perPage: 100 },
    sort: { field: "first_name", order: "ASC" },
  });

  const activeId = filterValues.sales_id;
  if (!sales || activeId == null || activeId === identity?.id) return null;
  const active = sales.find((s) => s.id === activeId);
  if (!active) return null;

  return (
    <ActiveFilterButton
      className={className}
      label={formatName(active)}
      value={{ sales_id: active.id }}
    />
  );
};
